import moment from "moment";

export function EncodeToBase64(texto) {
    const buff = Buffer.from(texto, "utf8");
    const base64 = buff.toString("base64");
    return base64;
}

export function DecodeFormBase64(texto) {
    const buff2 = Buffer.from(texto, "base64");
    const str = buff2.toString("utf8");
    return str;
}

export function DecodeBase64ToBytesArray(texto) {
    const buff2 = Buffer.from(texto, "base64");
    return buff2;
}

//Este conversor sirve para pasar un base64 spliteado, a un array de Bytes para mandar directamente al BE
export function base64ToByteArray(base64String) {
    return Array.from(Uint8Array.from(atob(base64String), c => c.charCodeAt(0)));
}

export const byteArrayToBase64Src = (contentType, byteArray) => {
    if (!byteArray || !contentType) return null;

    const base64String = btoa(
        byteArray.reduce((data, byte) => data + String.fromCharCode(byte), '')
    );

    return `data:${contentType};base64,${base64String}`;
};

export const isTokenActive = () => {
    // verifico que sea válido
    let fechaValidez = sessionStorage.getItem("accessTokenValidTo");

    if ((fechaValidez == null) || (!fechaValidez)) {
        return false;
    }
    var fechaActual = moment.utc();
    var fechaToken = moment.utc(fechaValidez.toString());
    const tiempoSesionRestante = fechaToken.diff(fechaActual, 'seconds');

    // verifico que no esté vencido
    return (tiempoSesionRestante > 0);
};

export function GetDescripcionMensaje(codigo) {
    let mensaje = "";

    switch (codigo) {
        case '0001':
            mensaje = 'Sin permisos para ingresar a la aplicacion';
            break;
        case '0002':
            mensaje = 'Aplicacion Inactiva';
            break;
        case '0003':
            mensaje = 'Clave Incorrecta';
            break;
        case '0004':
            mensaje = 'Usuario Inactivo';
            break;
        case '0005':
            mensaje = 'Error al consultar Aplicacion';
            break;
        case '0006':
            mensaje = 'Error al consultar Usuario';
            break;
        case '0007':
            mensaje = 'La contraseña se debe cambiar desde el SO Windows';
            break;
        case '0008':
            mensaje = 'Hash Incorrecto';
            break;
        case '0009':
            mensaje = 'Usuario Incorrecto o no Disponible para la Aplicación';
            break;
        case '0010':
            mensaje = 'Error al generar el Guid';
            break;
        case '0011':
            mensaje = 'Ocurrió un error al enviar el Mail';
            break;
        case '0012':
            mensaje = 'No se encontro Configuración de Mail o Template';
            break;
        case '0013':
            mensaje = 'Error al grabar la clave de usuario';
            break;
        case '0014':
            mensaje = 'Error al consultar Guid';
            break;
        case '0015':
            mensaje = 'Guid inválido o exiprado';
            break;
        case '0016':
            mensaje = 'Error Al verificar Politica de Contraseña';
            break;
        case '0017':
            mensaje = 'La contraseña No cumple con las Politicas de Seguridad';
            break;
        case '0018':
            mensaje = 'Ocurrió un error al verificar las Politicas de Seguridad';
            break;
        case '0019':
            mensaje = 'Ocurrió un error al verificar el Código y el Guid';
            break;
        case '0020':
            mensaje = 'El Código ingresado es incorrecto';
            break;
        case '0021':
            mensaje = 'No se ha encontrado el Usuario o Correo Electrónico';
            break;
        case '0022':
            mensaje = 'Usuario Bloqueado';
            break;
        case '0023':
            mensaje = 'Error al bloquear el usuario';
            break;
        case '0024':
            mensaje = 'Clave vencida';
            break;
        case '0025':
            mensaje = 'Usuario sin permiso de configuracion externa';
            break;
        case '0026':
            mensaje = 'La contraseña actual no es válida';
            break;
        case '0027':
            mensaje = 'El usuario no se encuentra vinculado';
            break;
        case '0028':
            mensaje = 'El Tipo de Usuario no se encuentra actualizado';
            break;
        case '0029':
            mensaje = 'El Tipo de Usuario no está habilitado para ingresar al sistema';
            break;
        default:
            mensaje = codigo;
    }

    return mensaje;
}

export const getUncompletedRequiredFields = (inputs, formData) => {
    const requiredInputs = inputs.filter(input => input.required);
    return requiredInputs.filter(input => {
        const inputType = typeof formData[input.name];
        return (inputType === 'string' && !Boolean(formData[input.name]?.trim()))
            || (input.type === 'file' && !Boolean(formData[input.name]?.archivo))
            || (inputType === 'number' && !Boolean(formData[input.name]) && formData[input.name] !== 0)
            || (Array.isArray(formData[input.name]) && !formData[input.name]?.length)
            || (inputType === 'object' && !Array.isArray(formData[input.name]) && !Boolean(formData[input.name]))
            || (inputType === 'undefined');
    });
}

export const dayMapper = {
    1: 'Lunes',
    2: 'Martes',
    3: 'Miércoles',
    4: 'Jueves',
    5: 'Viernes',
    6: 'Sábado',
    7: 'Domingo'
};

export const normalizeFilterValue = (val) => val?.toString()?.toUpperCase()?.trim() || '';

export const getUserCurrentLocation = () => {
    return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
            reject(new Error("Este navegador no soporta la geolocalización."));
            return;
        }

        const onUbicacionConcedida = (ubicacion) => {
            resolve({
                lat: ubicacion.coords.latitude,
                lng: ubicacion.coords.longitude
            });
        };

        const onErrorDeUbicacion = (error) => {
            // Si fue timeout con alta precisión, reintentamos con baja precisión
            if (error.code === error.TIMEOUT) {
                navigator.geolocation.getCurrentPosition(
                    onUbicacionConcedida,
                    onErrorFinal,
                    {
                        enableHighAccuracy: false, // fallback a red/IP
                        maximumAge: 20000,         // acepta posición de hasta 20s atrás
                        timeout: 20000             // 20s de espera para esta segunda oportunidad
                    }
                );
                return;
            }

            onErrorFinal(error);
        };

        const onErrorFinal = (error) => {
            let mensajeError;
            switch (error.code) {
                case error.PERMISSION_DENIED:
                    mensajeError = "Permiso denegado por el usuario.";
                    break;
                case error.POSITION_UNAVAILABLE:
                    mensajeError = "Posición no disponible.";
                    break;
                case error.TIMEOUT:
                    mensajeError = "Tiempo de espera agotado.";
                    break;
                default:
                    mensajeError = "Error desconocido al obtener la ubicación.";
                    break;
            }
            reject(new Error(mensajeError));
        };

        // Intento principal: alta precisión
        navigator.geolocation.getCurrentPosition(
            onUbicacionConcedida,
            onErrorDeUbicacion,
            {
                enableHighAccuracy: true,// Usa GPS si está disponible
                maximumAge: 0,// No cachear posiciones previas
                timeout: 8000  // Máximo 8s para obtener ubicación
            }
        );
    });
};

/**
 * Inserta una o más columnas después del campo indicado
 * @param {Array} columns - Lista original de columnas
 * @param {Object|Array} newColumns - Columna(s) a insertar
 * @param {string} fieldRefence - Field después del cual insertar
 * @param {string} position - Indicador de donde se debe posicionar la nueva columna
 * @returns {Array} Nueva lista con columnas insertadas
 */

export const insertColumnAfter = (columns, newColumns, fieldRefence, position = 'after') => {
    const index = columns.findIndex(col => col.field === fieldRefence);
    const cloned = [...columns];
    if (index !== -1) {
        const insertIndex = position === 'after' ? index + 1 : index;
        const columnsToInsert = Array.isArray(newColumns) ? newColumns : [newColumns];
        cloned.splice(insertIndex, 0, ...columnsToInsert);
    }
    return cloned;
};

/**
 * Elimina una o más columnas por su field
 * @param {Array} columns - Lista original de columnas
 * @param {string|Array} fieldsToRemove - Field(s) a eliminar
 * @returns {Array} Nueva lista sin las columnas indicadas
 */

export const removeColumnByField = (columns, fieldsToRemove) => {
    const fields = Array.isArray(fieldsToRemove) ? fieldsToRemove : [fieldsToRemove];
    return columns.filter(col => !fields.includes(col.field));
};